/* eslint-disable import/no-webpack-loader-syntax */ import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import diamondBlueUrl from '../../../assets/gems/diamond_blue.svg?inline';
export function DiamondBlue({ ...props }) {
    return /*#__PURE__*/ _jsx("img", {
        ...props,
        src: diamondBlueUrl,
        alt: "DiamondBlueImage"
    });
}
